import type { IToast } from '@components/molecules/toast'
import type { AuthScreen } from '../index'


export type ScreenTransition = typeof screenTransition[number]
export const screenTransition = ["visible", "hidden", "slide-in-left", "slide-in-right", "slide-out-left", "slide-out-right"] as const

export enum AuthActions {
    SET_TOAST = 'SET_TOAST',
    SET_SCREEN = 'SET_SCREEN',
    SET_TRANSITION_STATE = 'SET_TRANSITION_STATE',
    SET_IS_NEW_USER = 'SET_IS_NEW_USER',
    RESET = 'RESET',
}


interface setToast {
    type: typeof AuthActions.SET_TOAST
    payload: IToast
}
interface setScreen {
    type: typeof AuthActions.SET_SCREEN
    payload: AuthScreen
}
interface setTransitionState {
    type: typeof AuthActions.SET_TRANSITION_STATE
    payload: ScreenTransition
}
interface setIsNewUser {
    type: typeof AuthActions.SET_IS_NEW_USER
    payload: boolean
}

interface reset {
    type: typeof AuthActions.RESET
}

export type AuthActionTypes = (
    setToast |
    setScreen |
    setTransitionState |
    setIsNewUser |
    reset
)
